// Espelha backend/src/services/rolePolicy.js. A validação que vale é sempre a do
// backend; aqui é só para montar a interface.

export const ROLE_ORDER = ['admin', 'exxer', 'coordenador', 'professor', 'aluno', 'temporario'];

// Papéis com combinação restrita (espelha COMBINA_SOMENTE_COM da rolePolicy):
// admin com nenhum; temporário só com exxer.
export const COMBINA_SOMENTE_COM = {
  admin: [],
  temporario: ['exxer']
};

// Papéis que não podem ser acumulados com nenhum outro.
export const EXCLUSIVE_ROLES = Object.keys(COMBINA_SOMENTE_COM)
  .filter((papel) => COMBINA_SOMENTE_COM[papel].length === 0);

export const isExclusiveRole = (papel) => EXCLUSIVE_ROLES.includes(papel);

export const canCombine = (a, b) => {
  if (a === b) return true;
  if (COMBINA_SOMENTE_COM[a] && !COMBINA_SOMENTE_COM[a].includes(b)) return false;
  if (COMBINA_SOMENTE_COM[b] && !COMBINA_SOMENTE_COM[b].includes(a)) return false;
  return true;
};

// Todos os pares do conjunto precisam ser compatíveis.
export const isValidRoleSet = (papeis = []) => (
  papeis.length > 0 && papeis.every((a) => papeis.every((b) => canCombine(a, b)))
);

export const sortRoles = (papeis = []) => ROLE_ORDER.filter((papel) => papeis.includes(papel));

export const roleLabel = (papel, t) => t(`common:roles.${papel}`, papel);

// Quem pode conceder o quê (mesma hierarquia do cadastro).
export const GRANTABLE_ROLES_BY_ACTOR = {
  admin: ['exxer', 'coordenador', 'professor', 'aluno', 'temporario'],
  exxer: ['coordenador', 'professor', 'aluno'],
  coordenador: ['professor', 'aluno']
};

// Espelha backend/src/services/gestaoEscolarPolicy.js: admin sempre; exxer com
// a flag `gestao_escolar` (vem do /me). Os demais papéis não dependem dela.
export const temGestaoEscolar = (usuario) => (
  usuario?.tipo_usuario === 'admin' ||
  (usuario?.tipo_usuario === 'exxer' && Number(usuario?.gestao_escolar) === 1)
);

// Espelha podeGerirLicencas (backend/src/services/licencas/chaveLicencaPolicy.js):
// gerar, revogar e rotacionar chaves. Exxer precisa das duas flags.
export const temGestaoLicencas = (usuario) => (
  usuario?.tipo_usuario === 'admin' ||
  (usuario?.tipo_usuario === 'exxer' && temGestaoEscolar(usuario) && Number(usuario?.licencas) === 1)
);

// Aba Licenças: quem gere e o coordenador (que só vê e copia as da escola).
export const temAcessoLicencas = (usuario) => (
  temGestaoLicencas(usuario) || usuario?.tipo_usuario === 'coordenador'
);

// Espelha backend/src/services/assinaturas/assinaturasPolicy.js (temAcessoAssinaturas):
// tela Assinaturas. Admin sempre; exxer com a flag `assinaturas` (vem do /me).
export const temAcessoAssinaturas = (usuario) => (
  usuario?.tipo_usuario === 'admin' ||
  (usuario?.tipo_usuario === 'exxer' && Number(usuario?.assinaturas) === 1)
);

// Espelha backend/src/services/prestacao/prestacaoPolicy.js (acessoPrestacao): o /me devolve
// `prestacao_contas: { colaborador, financeiro, admin, fase_teste, piloto, modo }` já calculado pelo backend
// (papel ativo, flag `financeiro`, interruptor PRESTACAO_CONTAS_LIBERADA = 0/financeiro/1 e TV do Andon).
// Aqui só se lê o objeto; a API confere de novo em toda rota.
export const temAcessoPrestacao = (usuario) => usuario?.prestacao_contas?.colaborador === true;
export const temAcessoFinanceiro = (usuario) => usuario?.prestacao_contas?.financeiro === true;

export const grantableRolesFor = (actorRole) => sortRoles(GRANTABLE_ROLES_BY_ACTOR[actorRole] || []);

// Papéis oferecíveis como acumulação para um cadastro de papel base.
// Inclui o próprio papel base (quando o ator pode concedê-lo) e só os papéis
// que podem conviver com ele: na tela de Exxer o admin vê também Temporário;
// na de Temporários, só Exxer.
export const combinableRolesFor = (actorRole, papelBase) => {
  if (isExclusiveRole(papelBase)) return [];
  return grantableRolesFor(actorRole).filter((papel) => canCombine(papelBase, papel));
};
